import { SectionHeading } from './SectionHeading';
import { FAQItem } from './FAQItem';
import { faq } from '../content/site';
import styles from './FAQSection.module.css';
export function FAQSection() {
  return (
    <section className={styles.section}>
      <SectionHeading eyebrow="Вопросы и ответы" title="Что важно знать до начала работы" />
      {faq.map((x, i) => (
        <FAQItem key={x.q} question={x.q} answer={x.a} defaultOpen={i === 0} />
      ))}
    </section>
  );
}
